<template>
  <div>
    <div class="content-tabs-wrapper">
      <Tabs justified class="analytics-tabs" @change="handleAfterChange">
        <!-- Scores Graph -->
        <Tab>
          <div slot="title">
            <fai :icon="['fas', 'chart-line']" class='mr-1' />scores graph
          </div>
          <ScoresGraphContainer v-if="activeTab === 0" :active="activeTab === 0" />
        </Tab>

        <!-- Score Ranking -->
        <Tab>
          <div slot="title">
            <fai :icon="['far', 'chart-bar']" class='mr-1' />score ranking
          </div>
          <StoreRankingContainer v-if="activeTab === 1" :active="activeTab === 1" />
        </Tab>
      </Tabs>
    </div>
  </div>
</template>

<script>
  import ScoresGraphContainer from './Tabs/ScoresGraphContainer';
  import StoreRankingContainer from './Tabs/StoreRankingContainer';
  import { Tabs, Tab, Tooltip } from 'uiv';

  export default {
    name: 'AnalyticsLandingPage',
    components: {
      ScoresGraphContainer,
      StoreRankingContainer,
      Tab,
      Tabs,
      Tooltip
    },
    data() {
      return {
        activeTab: 0
      }
    },
    methods: {
      handleAfterChange(index) {
        this.activeTab = index;
      }
    }
  }
</script>
